<atn-ds-table [config]="appsTableConfigSg()" />

<atn-admin-app-modal />
<atn-quiver-deployment-modal />

@if (appsEc.plugins.editingPlugin.feature.selectors.hasDeletions.asSignal()) {
  @let deletionError =
    appsEc.plugins.editingPlugin.feature.selectors.submissionError.asSignal();
  <atn-ds-confirmation-overlay
    title="Delete App"
    [description]="
      'Are you sure you want to delete <b>' +
      appNameForDeleteSg() +
      '</b>? This action cannot be undone. ' +
      '<br> Please type <b>' +
      appNameForDeleteSg() +
      '</b> in the field below to confirm this action.'
    "
    [error]="deletionError"
    [validation]="appNameForDeleteSg()"
    (cancel)="cancelDeletionClickHandler()"
    (confirm)="confirmDeletionClickHandler()"
    confirmButtonText="Delete"
  />
}
